<template>
  <div
    v-if="userInfo"
    class="close-statement"
    :class="{
      'close-statement--android': $isAndroid,
    }"
  >
    <div class="close-statement__title">
      Согласие на сбор и обработку персональных данных
    </div>
    <div class="close-statement__main">
      <div class="close-statement__main_block">
        Я, {{ userInfo.fio }},<br />ИИН {{ userInfo.iin }}, даю свое согласие АО «Kaspi Bank» БИН 971240001315 (далее – Kaspi) на:
      </div>
      <ol>
        <li>
          Сбор, обработку Kaspi указанных мною персональных данных и данных моих несовершеннолетних
          детей/подопечных (далее - Данные), в том числе их трансграничную передачу, на
          фотографирование меня и моих документов;
        </li>
        <li>
          Предоставление моих Данных и сведений обо мне от Kaspi третьим лицам, в уполномоченную
          организацию по выплате пенсий, в базы данных государственных органов, организаций и лиц,
          напрямую и через третьих лиц, а также получение такой информации обо мне, в том числе
          содержащей мои Данные, от указанных лиц в нижеуказанных целях.
        </li>
        <li>
          Использование Kaspi моих Данных в целях (далее - Цели):<br />
          <ul>
            <li>
              заключения и исполнения любых сделок, в том числе приобретения товаров, работ или
              услуг, с использованием сервисов в мобильном приложении Kaspi;
            </li>
            <li>
              получения государственных услуг и иных услуг, связанных с реализацией моих прав и
              обязанностей, предусмотренных законодательством Республики Казахстан при
              взаимодействии с государственными органами и организациями, включая НАО
              «Государственная корпорация «Правительство для граждан» и иные;
            </li>
            <li>выпуска электронной цифровой подписи Удостоверяющего центра АО «Kaspi Bank»;</li>
            <li>предоставления сведений об услугах Kaspi и его партнеров;</li>
            <li>совершения транзакций или облачной обработки Данных за пределами страны;</li>
            <li>
              распространения моих Данных в общедоступных источниках для взыскания любых
              задолженностей, возникших у меня перед Kaspi;
            </li>
            <li>
              выявления случаев мошенничества, хищения денег со счета, иных противоправных действий,
              предотвращения таких противоправных действий или локализации последствий таких
              действий;
            </li>
            <li>
              исполнения мероприятий по противодействию отмыванию доходов, полученных незаконным
              путем, финансированию терроризма, экстремизма, разработки оружия массового
              уничтожения.
            </li>
          </ul>
        </li>
      </ol>
      <div class="close-statement__main_block">
        Настоящее согласие действует в течение 3 (трех) лет с даты его предоставления.
      </div>
     
    </div>
    <div class="close-statement__divider"></div>
    <CommonButton class="close-statement__btn" @click="goToScoring">
      Я согласен, продолжить
    </CommonButton>
  </div>
</template>

<script>

import CommonButton from "@/components/shared/button/CommonButton";
import { saveConsent } from "@/api/consent";

export default {
  components: {
    CommonButton,
  },
  props: {
    userInfo: {
      type: [Object, null],
      required: true,
    },
  },

  methods: {
    async goToScoring() {
      await saveConsent(true);
      this.$router.replace("/bank/red/limits");
    },
  }
};
</script>
